import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

function changeBackgroundColor() {
    gsap.to('.transparent-navbar', {
        backgroundColor: '#1F4FBE',
        scrollTrigger: {
            start: 0,
            end: 100,
            scrub: true,
        },
    });
}

function changeNavLinksOnScroll() {
    gsap.to('.nav-link', {
		color: '#ffffff',
        scrollTrigger: {
            start: 0,
            end: 100,
            scrub: true,
        },
    });
}

// function changeNavLogoOnScroll() {
//     gsap.to('.navbar-brand', {
// 		top: '0',
// 		height: '7.81rem',
// 		width: '7.81rem',
//         scrollTrigger: {
//             start: 0,
//             end: 100,
//             scrub: true,
//         },
//     });
// }



export default function initNavScroll() {
    gsap.registerPlugin(ScrollTrigger);

    changeBackgroundColor();
    changeNavLinksOnScroll();
	// changeNavLogoOnScroll();
}
